<div class="menu-header-wrapper">
  <div
    nz-tooltip
    [nzTooltipColor]="'#fff'"
    [nzTooltipTitle]="
      hideHeaderTooltip ? null : (headerTooltip ?? params.displayName)
    "
    class="custom-header"
    (click)="onHeaderClick()"
  >
    @if (params.displayName) {
      <span class="custom-header-label ag-header-cell-text">{{
        params.displayName
      }}</span>
    }
    @if (extraInfoPopoverConfig(); as config) {
      <wilson-handbook-info-icon
        [title]="config.titleKey | translate"
        [content]="config.contentKey | translate"
        [linkUrl]="config.linkUrl"
        [linkText]="config.linkTextKey ?? '' | translate"
        placement="left"
        class="extra-info-icon"
      />
    }
    @if (params.enableSorting) {
      @if (sort === 'asc') {
        <span class="ag-icon ag-icon-asc"></span>
      }
      @if (sort === 'desc') {
        <span class="ag-icon ag-icon-desc"></span>
      }
    }
  </div>
  @if (!hideColumnVisibilityMenu) {
    <fa-icon
      [icon]="faEllipsisVertical"
      (click)="openColumnsModal()"
      class="dropdown-icon"
    ></fa-icon>
  }
</div>
